import { ChevronDown, LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import AvatarWithFallback from "@/shared/components/avatar-with-fallback/avatar-with-fallback";
import { useAuth } from "@/core/context/AuthContext";
import { useTranslation } from "react-i18next";
import { useSelector } from "@/core/redux/store";

export default function UserDropdown() {
  const { logout } = useAuth();
  const { t } = useTranslation();
  const me = useSelector((state) => state.user.me);

  const userName =
    me?.firstName || me?.lastName
      ? `${me.firstName || ""} ${me.lastName || ""}`.trim()
      : "";

  const profilePictureUrl = me?.profilePictureUrl;
  const userEmail = me?.email || "";

  const handleLogout = () => {
    logout();
  };

  const displayName = userName || userEmail || "User";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex items-center gap-[4px] cursor-pointer">
          <AvatarWithFallback
            src={profilePictureUrl}
            alt={userName || "User"}
            name={displayName}
            size={32}
          />
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 !p-0 !shadow-md">
        {/* User Info Section */}
        <div className="py-[8px] px-[12px]">
          <DropdownMenuLabel className="p-0 font-normal">
            <div className="flex items-center gap-2">
              <AvatarWithFallback
                src={profilePictureUrl}
                alt={userName || "User"}
                name={displayName}
                size={32}
              />
              <div className="flex flex-col gap-[2px] flex-1 min-w-0">
                {userName ? (
                  <span className="truncate text-sm font-700 text-[#3F3F46]">
                    {userName}
                  </span>
                ) : (
                  <span className="text-sm text-zinc-500">Logged in as</span>
                )}
                {userEmail && (
                  <span className="truncate text-xs font-500 text-[#3F3F46]">
                    {userEmail}
                  </span>
                )}
              </div>
            </div>
          </DropdownMenuLabel>
        </div>

        {/* Separator */}
        <DropdownMenuSeparator className="!m-0" />

        {/* Log out Section */}
        <div className="py-[12px] px-[12px]">
          <DropdownMenuItem
            className="cursor-pointer !p-0"
            onClick={handleLogout}
          >
            <LogOut className="w-4 h-4 mr-[4px]" />
            <span className="text-sm">{t("log_out")}</span>
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
